import { Box, Button, Divider } from '@mui/material';
import React from 'react';

// Constants from AppShell
const BOTTOM_NAV_HEIGHT = 86;
const EXTRA_GUTTER = 12;
const TOTAL_BOTTOM_SPACE = BOTTOM_NAV_HEIGHT + EXTRA_GUTTER; // 98px

export default function FilterPopup({ children, boxStyle, onApply, onClear, onRequestClose }) {
  const handleApply = () => {
    const shouldClose = onApply?.();
    if (shouldClose === true) {
      onRequestClose?.();
    }
  };

  const handleClear = () => {
    onClear?.();
  };

  return (
    <>
      <Box
        sx={{
          // Mobile-aware maxHeight that accounts for bottom nav bar
          maxHeight: {
            xs: `calc(65vh - ${TOTAL_BOTTOM_SPACE}px - env(safe-area-inset-bottom, 0px))`,
            md: '75vh',
          },
          maxWidth: {
            xs: 'calc(100vw - 3rem)',
            sm: '80vw',
          },
          overflowY: 'auto',
          overflowX: 'hidden',
          // Smooth scrolling
          WebkitOverflowScrolling: 'touch',
          ...boxStyle,
        }}
      >
        {children}
      </Box>
      <Divider />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          padding: 1.5,
          gap: 1,
          // Ensure buttons don't disappear
          backgroundColor: 'background.paper',
          position: 'sticky',
          bottom: 0,
          zIndex: 1,
        }}
      >
        <Button
          variant="text"
          color="inherit"
          onClick={handleClear}
          sx={{
            borderRadius: 2,
            minWidth: { xs: 80, sm: 100 },
          }}
        >
          Clear All
        </Button>
        <Button
          variant="contained"
          onClick={handleApply}
          sx={{
            borderRadius: 2,
            minWidth: { xs: 80, sm: 100 },
          }}
        >
          Apply
        </Button>
      </Box>
    </>
  );
}
